"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ImageCarouselActions;
(function (ImageCarouselActions) {
    ImageCarouselActions["CurrentImageChanged"] = "CurrentImageChanged";
    ImageCarouselActions["Closed"] = "Closed";
})(ImageCarouselActions || (ImageCarouselActions = {}));
exports.default = ImageCarouselActions;
